"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapButtonSizeToSpinnerSize = exports.mapCalloutSizeToTextSize = exports.mapResponsiveProp = void 0;
function mapResponsiveProp(propValue, mapValue) {
    if (propValue === undefined)
        return undefined;
    if (typeof propValue === 'string') {
        return mapValue(propValue);
    }
    return Object.fromEntries(Object.entries(propValue).map(([key, value]) => [key, mapValue(value)]));
}
exports.mapResponsiveProp = mapResponsiveProp;
function mapCalloutSizeToTextSize(size) {
    return size === '3' ? '3' : '2';
}
exports.mapCalloutSizeToTextSize = mapCalloutSizeToTextSize;
function mapButtonSizeToSpinnerSize(size) {
    switch (size) {
        case '1':
            return '1';
        case '2':
        case '3':
            return '2';
        case '4':
            return '3';
    }
}
exports.mapButtonSizeToSpinnerSize = mapButtonSizeToSpinnerSize;
//# sourceMappingURL=map-prop-values.js.map